import styled from '@emotion/styled'

export const ServerNameMt5 = styled.div`
  align-items: center;
  background: #EBF8E4;
  border-radius: 4px;
  color: #999999;
  display: flex;
  gap: 10px;
  justify-content: center;
  padding: 0px 9px;
  width: 164px;
`
